import { upperCase } from '@art-suite/art-core-ts';

/**
 * get a human-readable short ID for any UUID
 * possible search terms: id.split('-')[0] or id.substring(0, 8) or
 */
export const getHumanReadablePartialId = (id: string | undefined): string => {
  if (!id) return '--';
  return kaiPartialIdPresenter(id);
};

export const kaiPartialIdPresenter = (id: string) => upperCase(id.substring(0, 8));
